(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-conversion-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-purchase-tools')) customElements.define('pv-purchase-tools',class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-pv-variants]').textContent);
      this.variants.forEach(v=>v.breaks.sort((a,b)=>a.min-b.min));
      this.labels = JSON.parse(this.querySelector('[data-pv-labels]').textContent);
      this.info = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) {document.addEventListener('DOMContentLoaded',()=>this.initialize(),{once:true,signal:this.abort.signal});} else this.initialize();
    }
    initialize() {
      if(this.ready)return;
      this.form=document.getElementById(`product-form-${this.dataset.section}`);
      if(!this.form)return;
      this.ready=true;
      this.money=new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:this.dataset.currency||'EUR'});
      this.nativeButton=this.form.querySelector('[type="submit"]');
      const preferred=this.variants.find(v=>String(v.id)===this.dataset.preferred && v.available);
      const url=new URL(location.href);
      if(preferred&&!url.searchParams.has('variant')&&!url.searchParams.has('option_values')&&!url.searchParams.has('selling_plan')&&!window.Shopify?.designMode) {url.searchParams.set('variant',preferred.id);location.replace(url.href);return;}
      if(this.dataset.sticky==='true'){
        this.rail=this.querySelector('template').content.firstElementChild.cloneNode(true);
        document.body.append(this.rail);
        this.rail.querySelector('[data-sticky-title]').textContent=this.dataset.productTitle;
        this.rail.querySelector('button').addEventListener('click',()=>{
          const quantity=this.quantity();
          if(quantity&&!quantity.reportValidity()) {quantity.scrollIntoView({block:'center',behavior:'smooth'});return;}
          if(this.nativeButton.disabled||this.nativeButton.getAttribute('aria-disabled')==='true')return;
          this.form.requestSubmit(this.nativeButton);
        },{signal:this.abort.signal});
        this.intersection=new IntersectionObserver(entries=>{this.nativeVisible=entries[0].isIntersecting;this.updateRail();});
        this.intersection.observe(this.nativeButton);
      }
      this.info.addEventListener('change',()=>this.schedule(),{signal:this.abort.signal});
      this.info.addEventListener('input',()=>this.schedule(),{signal:this.abort.signal});
      this.addEventListener('change',event=>{
        if(event.target.matches('[data-pv-quantity]')) {
          const qty=this.quantity();if(qty){qty.value=event.target.value;qty.dispatchEvent(new Event('change',{bubbles:true}));}
        }
      },{signal:this.abort.signal});
      this.observer=new MutationObserver(records=>{if(records.some(r=>!this.contains(r.target)))this.schedule();});
      this.observer.observe(this.info,{childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled','aria-disabled']});
      this.form.addEventListener('formdata',event=>this.attachGift(event.formData),{signal:this.abort.signal});
      window.addEventListener('resize',()=>this.updateRail(),{signal:this.abort.signal});
      this.refresh();
    }
    schedule(){clearTimeout(this.pending);this.pending=setTimeout(()=>this.refresh(),60);}
    quantity(){return document.getElementById(`Quantity-${this.dataset.section}`);}
    selected(){return this.variants.find(v=>String(v.id)===String(this.form.querySelector('[name="id"]').value));}
    plan(variant){const id=this.form.querySelector('[name="selling_plan"]')?.value;return variant?.plans.find(p=>String(p.id)===String(id));}
    format(value){return this.money.format(value/100);}
    price(variant,count){let price=variant.price;for(const tier of variant.breaks){if(count>=tier.min)price=tier.price;}return price;}
    refresh(){
      if(!this.isConnected||!this.form)return;
      const v=this.selected();if(!v)return;
      const plan=this.plan(v),qty=Number(this.quantity()?.value||v.min||1);
      const field=this.querySelector('.pv-quantity-offers');
      if(field){
        const min=Number(this.quantity()?.min||v.min||1),step=Number(this.quantity()?.step||v.step||1);
        const max=Number(this.quantity()?.max||v.max||Infinity);
        const counts=[...new Set([min,...v.breaks.map(b=>b.min),min+step,min+step*2])].sort((a,b)=>a-b).slice(0,3);
        const signature=JSON.stringify([v.id,plan?.id,min,step,max,counts]);
        if(signature!==this.signature){
          const box=field.querySelector('[data-quantity-options]');box.replaceChildren();
          counts.forEach(count=>{
            const unit=plan?plan.price:this.price(v,count);
            const label=document.createElement('label'),radio=document.createElement('input');
            radio.type='radio';radio.name=`pv-quantity-${this.dataset.section}`;radio.value=count;radio.dataset.pvQuantity='';radio.disabled=!v.available||count>max||(count-min)%step!==0;
            const title=document.createElement('strong');title.textContent=`${count} ×`;
            const total=document.createElement('span');total.textContent=`${this.labels.total}: ${this.format(unit*count)}`;
            const each=document.createElement('small');each.textContent=`${this.format(unit)} ${this.labels.unit}`;
            label.append(radio,title,total,each);
            if(!plan&&unit<v.price){const saving=document.createElement('small');saving.className='pv-offer-saving';saving.textContent=`−${Math.floor((v.price-unit)*100/v.price)} %`;label.append(saving);}
            box.append(label);
          });this.signature=signature;
        }
        field.hidden=false;
        field.querySelectorAll('input').forEach(r=>r.checked=Number(r.value)===qty);
      }
      const saving=this.querySelector('[data-saving]');
      const price=plan?.price||this.price(v,qty);
      saving.hidden=!(v.compare>price&&!plan);
      if(!saving.hidden)saving.textContent=`${this.format(v.compare)} → ${this.format(price)} (−${Math.floor((v.compare-price)*100/v.compare)} %)`;
      this.querySelector('[data-preferred-label]').hidden=String(v.id)!==this.dataset.preferred;
      const gift=this.querySelector('[data-gift]');if(gift)gift.hidden=!!plan||qty<Number(this.dataset.giftMin);
      const daily=this.querySelector('[data-daily]');const days=Number(this.dataset.days);
      daily.hidden=!(plan&&days>0&&String(v.id)===this.dataset.supplyVariant);
      if(!daily.hidden)daily.querySelector('[data-daily-price]').textContent=`${this.format(Math.round(plan.price/days))} pro Tag`;
      this.currentDescription=`${qty} × ${v.title==='Default Title'?'':v.title+' · '}${this.format(price*qty)}${plan?' · '+this.labels.subscription:''}`;
      this.updateRail();
    }
    attachGift(data){
      if(!this.dataset.giftId)return;
      const v=this.selected(),qty=Number(data.get('quantity')||this.quantity()?.value||1);
      if(!v||this.plan(v)||qty<Number(this.dataset.giftMin))return;
      const fields=[...data.entries()];
      for(const [key,value] of fields){
        if(key==='id'||key==='quantity'||key==='selling_plan'){data.delete(key);data.set(`items[0][${key}]`,value);}
        else if(key.startsWith('properties[')){data.delete(key);data.set(`items[0][properties]${key.slice(10)}`,value);}
      }
      data.set('items[0][quantity]',String(qty));data.set('items[1][id]',this.dataset.giftId);data.set('items[1][quantity]','1');
    }
    updateRail(){
      if(!this.rail)return;
      const preview=document.getElementById('PBarNextFrame');
      const rect=preview?.getBoundingClientRect();
      const offset=rect&&rect.height>0&&rect.top<innerHeight?Math.min(rect.height,70):0;
      this.rail.style.setProperty('--pv-preview-bottom',`${offset}px`);
      this.rail.hidden=!!this.nativeVisible;
      this.rail.querySelector('[data-sticky-description]').textContent=this.currentDescription||'';
      const button=this.rail.querySelector('button');
      button.disabled=this.nativeButton.disabled||this.nativeButton.getAttribute('aria-disabled')==='true';
      button.textContent=this.nativeButton.disabled?this.labels.unavailable:this.labels.add;
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.intersection?.disconnect();clearTimeout(this.pending);this.rail?.remove();}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-product-review-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const badge = event.target.closest('.pv-product-reviews__rating .jdgm-preview-badge');
    if (badge) {
      const details = badge.closest('product-info')?.querySelector('.pv-product-reviews details');
      if (details) details.open = true;
    }
  }, true);

  const revealProductReviews = () => {
    if (window.location.hash !== '#judgeme_product_reviews') return;
    const details = document.querySelector('.pv-product-reviews details');
    if (details) details.open = true;
  };
  document.addEventListener('DOMContentLoaded', revealProductReviews);
  window.addEventListener('hashchange', revealProductReviews);
  } catch(e) { console.error(e); }
})();

})();
